const hisenseHubspotStyles = `
    form.hs-form {
        width: 100% !important;
        align-self: center;
    }
    .hs-form fieldset {
        max-width: 100% !important;
    }
    .hs-form-field {
        display: flex;
        flex-direction: column;
        margin-bottom: 16px;
        color: #525454;
        font-family: wfont_744d4e_73608e814da149c7967360c8d58ca60c, wf_73608e814da149c7967360c8d, orig_hisense_alfabet_light;
        font-size: 16px;
        padding-bottom: 10px;
    }
    .hs-input {
        width: 100% !important;
        height: 46px;
        padding: 10px;
        border: 1px solid #525454;
        border-radius: 5px;
        font-size: 16px;
        font-family: wfont_744d4e_73608e814da149c7967360c8d58ca60c, wf_73608e814da149c7967360c8d, orig_hisense_alfabet_light;
        margin-top: 5px;
    }

    .hs-input[type="file"] {
        height: 140px;
    }

    .hs-input[type="checkbox"] {
        width: 17px !important;
        height: 17px !important;
        cursor: pointer;
        
    }

    .hs-input[type="checkbox"]:checked {
        accent-color: rgb(0, 102, 100) !important;
        color: white;
    }

    .hs-input is-placeholder {
        font-family: wfont_744d4e_73608e814da149c7967360c8d58ca60c, wf_73608e814da149c7967360c8d, orig_hisense_alfabet_light;
        font-size: 16px;
    }

    .hs-error-msgs {
        color: red;
        font-family: wfont_744d4e_73608e814da149c7967360c8d58ca60c, wf_73608e814da149c7967360c8d, orig_hisense_alfabet_light;
        font-size: 16px;
        margin-top: 10px;
    }

    .hs-button {
        background-color: rgb(0, 102, 100);
        color: white;
        border: none;
        padding: 10px 60px;
        border-radius: 300px;
        cursor: pointer;
        font-family: wfont_d9cde4_dea7f99b83cb4e2d9c5c438fb7ce4582, wf_dea7f99b83cb4e2d9c5c438fb, orig_hisense_alfabet_medium;
        font-size: 20px;
        transition: background-color 0.3s ease;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }

    .hs-button:hover {
        background-color: #103A42;
    }

    .hs-main-font-element h3 {
        font-family: wfont_744d4e_73608e814da149c7967360c8d58ca60c, wf_73608e814da149c7967360c8d, orig_hisense_alfabet_light;
        font-size: 24px;
        padding-bottom: 5px;
    }

    .hs-main-font-element p {
        font-family: wfont_744d4e_73608e814da149c7967360c8d58ca60c, wf_73608e814da149c7967360c8d, orig_hisense_alfabet_light;
        font-size: 16px;
        padding-bottom: 10px;
    }

    .hs-fieldtype-textarea {
        min-height: 125px !important;
    }

    #receipt-b1ac2ab9-4518-4c6b-bfc7-2423f95656a2,
    #receipt-044cb92d-6889-43ad-8338-5fcf364ddcb3,
    #receipt-52a2a1dd-d566-4d78-b412-2a8791eab9c2,
    #receipt-52a2a1dd-d566-4d78-b412-2a8791eab9c2,
    #installation_location_photo-52a2a1dd-d566-4d78-b412-2a8791eab9c2 {
        display: none;
    }

    label#label-receipt-b1ac2ab9-4518-4c6b-bfc7-2423f95656a2,
    label#label-receipt-044cb92d-6889-43ad-8338-5fcf364ddcb3,
    label#label-receipt-52a2a1dd-d566-4d78-b412-2a8791eab9c2 {
        height: 46px;
        display: flex;
        padding: 10px 20px;
        color: #006664;
        background-color: white;
        font-size: 16px;
        border: 1px solid #525454;
        cursor: pointer;
        border-radius: 5px;
        width: 100%;
        justify-content: center; 
        align-items: center;
        text-align: center; 
        gap: 5px;
        box-sizing: border-box;
    }

    /* Style for the label */
    label#label-receipt-044cb92d-6889-43ad-8338-5fcf364ddcb3,
    label#label-receipt-b1ac2ab9-4518-4c6b-bfc7-2423f95656a2,
    label#label-receipt-52a2a1dd-d566-4d78-b412-2a8791eab9c2,
    label#label-installation_location_photo-52a2a1dd-d566-4d78-b412-2a8791eab9c2 {
        height: 46px;
        display: flex;
        padding: 10px 20px;
        color: #006664;
        background-color: white;
        font-size: 16px;
        border: 1px solid #525454;
        cursor: pointer;
        border-radius: 5px;
        width: 100%;
        justify-content: center;
        align-items: center;
        text-align: center;
        gap: 5px;
        box-sizing: border-box;
    }

    /* Additional styling for the file input container */
    .hs_receipt.hs-receipt.hs-fieldtype-file.field.hs-form-field {
        display: flex;
        flex-direction: column; /* Stack the text and label */
        justify-content: center;
        align-items: flex-start; /* Align the label to the left */
        padding: 0px 10px 0px 0px;
    }

    #installation_location_photo-52a2a1dd-d566-4d78-b412-2a8791eab9c2 {
        display: none; /* Hide the actual input */
    }

    /* Add the "Receipt" text before the label, outside the box */
    .hs_installation_location_photo::before {
        content: "Installation Location Photo*";
        font-size: 16px;
        color: #525454;
        text-align: left;
        width: 100%;
        margin-bottom: 5px;
        display: flex;
        justify-content: left;
        align-items: flex-start;
    }

    /* Add the "Receipt" text before the label, outside the box */
    .hs_receipt.hs-receipt.hs-fieldtype-file.field.hs-form-field::before {
        content: " Receipt photo*";
        font-size: 16px;
        color: #525454;
        text-align: left;
        width: 100%;
        margin-bottom: 5px;
        display: flex;
        justify-content: left;
        align-items: flex-start;
    }


    /* Additional styling for the file input container */
    .hs_installation_location_photo hs-installation_location_photo hs-fieldtype-file field hs-form-field {
        display: flex;
        flex-direction: column; /* Stack the text and label */
        justify-content: center;
        align-items: flex-start; /* Align the label to the left */
        padding: 0px 10px 0px 0px;
    }



    /* Responsive Fix: Reset Flexbox on Mobile */
    @media screen and (max-width: 768px) {
        fieldset.form-columns-2 {
            display: block; /* Stack elements on mobile */
            
        }
    }
`;

module.exports = {
  hisenseHubspotStyles,
};
